<div class="text-center">
    <mat-icon>developer_board</mat-icon>
    <h1 mat-dialog-title translate> dialog.slotmodel.title</h1>
  
    <div class="modal-body" mat-dialog-content>
  
        <help-alert text = "help.page.slot_model.model_field" info = "help.info" description = "help.page.slot_model.model_description"></help-alert>

        <div class="card container">
            <div class="row mt-2">
                <div class="col-md">
                    <mat-form-field class = "full-width">
                        <mat-label translate>dialog.slotmodel.name</mat-label>
                        <input [(ngModel)]="slotModel.name" matInput>
                    </mat-form-field>
                </div>
            </div>
        </div>

        <div class="card container mt-3">
            <div class="row mt-2">
                <div class="col-md">
                    <mat-form-field>
                    <mat-label translate>dialog.slotmodel.level</mat-label>
                    <mat-select [(ngModel)]="slotModel.type" (selectionChange)="getList()" matNativeControl>
                        <mat-option *ngFor="let type of types" [value]="type.id">
                        {{type.name}}
                        </mat-option>
                    </mat-select>
                    </mat-form-field>
                </div>
                <div class="col-md">
                    <mat-form-field>
                    <mat-label *ngIf="slotModel.type==10" translate>dialog.slotmodel.site</mat-label>
                    <mat-label *ngIf="slotModel.type==20" translate>dialog.slotmodel.org</mat-label>
                    <mat-select [(ngModel)]="slotModel.typeId" matNativeControl>
                        <mat-option *ngFor="let element of list" [value]="element.id">
                        {{element.name}}
                        </mat-option>
                    </mat-select>
                    
                    
                    </mat-form-field>
                </div>
            </div>
        </div>

        <div class="card container mt-3">
                
            <div class="row mt-2">
                <div class="col-md">
                    <mat-form-field class = "full-width">
                        <mat-label translate>dialog.slotmodel.note</mat-label>
                        <input [(ngModel)]="slotModel.note" matInput>
                    </mat-form-field>
                </div>               
            </div>
            <div class="row mt-2">
                <div class="col-sm mt-3">
                    <mat-checkbox [(ngModel)]="slotModel.enabled">
                        <span translate>dialog.slotmodel.enabled</span>
                    </mat-checkbox>
                </div>                
            </div>
        </div>

  
      
    </div>
  
  
    <div class="modal-footer" mat-dialog-actions translate>

        <button type="button" class="btn btn-outline-danger" (click)="cancel()" translate>
        dialog.service.generic.cancel
        </button>

        <button *ngIf="slotModel.id != null" type="button" class="btn btn-outline-secondary" (click)="update()"
        translate>
        dialog.service.update.confirm
        </button>

        <button *ngIf="slotModel.id == null" type="button" class="btn btn-outline-secondary" (click)="update()"
        translate>
        dialog.service.create.confirm
        </button>


    </div>

</div>